import _ from "lodash";
import {
  Component,
} from "react";
import {
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  setupAntragPanels,
} from "App/shk-form-tab";

import {
  subpanels as subpanels_stamm,
} from "App/person-stamm-tab";
import {
  subpanels as subpanels_studien,
} from "App/person-studien-tab";
import {
  subpanels as subpanels_lbvperson,
} from "App/person-lbvperson-tab";
import {
  subpanels as subpanels_lbvstatus,
} from "App/person-lbvstatus-tab";
import {
  istArtTarifvertrag,
  istTypWerkvertrag,
  ROLLEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
  VERTRAGSARTEN_VORTRAG,
} from "App/constants";

const panels = _.cloneDeep([...subpanels_stamm, ...subpanels_studien, ...subpanels_lbvperson, ...subpanels_lbvstatus]);

/*
 * Hintergrund: Am Antrag gibt es keine separaten Endpunkte je Untertabelle sondern nur einen, der die jeweiligen Arrays
 *              als künstliche Properties mit dem Namen der Tabelle dem Antragsdatensatz hinzufügt. Das folgende Mapping
 *              definiert, welche Endpunkte auf welche Property am Antrag projiziert werden und wie sich dabei die Feldnamen
 *              vom Prefix her ändern:
 */
const mapping = [{ endpoint: "/api/shkperson/person", prop: "antrag_person", pfrom: "p_", pto: "ap_" },
                 { endpoint: "/api/shkperson/studienbereich", prop: "antrag_studienbereich", pfrom: "psb_", pto: "asb_" },
                 { endpoint: "/api/shkperson/werdegang", prop: "antrag_werdegang", pfrom: "pwg_", pto: "awg_" },
                 { endpoint: "/api/shkperson/lbvstatus", prop: "antrag_lbvstatus", pfrom: "lbs_", pto: "als_" },
                 { endpoint: "/api/shkperson/lbvperson", prop: "antrag_lbvperson", pfrom: "lbp_", pto: "alv_" }];
setupAntragPanels(panels, mapping);

const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user", "flag_antragstellermodus")
@antragApi.current
export default class AntragPersonTab extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { currentAntrag, user } = this.props;
    if (!currentAntrag) {
      return <Spinner />;
    }

    if (user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      const personPanel = panels.find(p => p.key == "stamm");
      personPanel.schema.table = _.filter(personPanel.schema.table, f => f.field != "ap_svakey");
    }

    let mypanels = _.cloneDeep(panels);

    const istWerkvertrag = istTypWerkvertrag(currentAntrag.a_katid);
    const istLehrauftrag = currentAntrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;
    const istTarifvertrag = istArtTarifvertrag(currentAntrag.a_artid);
    const istVortrag = VERTRAGSARTEN_VORTRAG.indexOf(currentAntrag.a_artid) >= 0;

    if (istWerkvertrag) {
      // Werkvertrag-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "buwbv", "adresse", "bank", "werkvertrag"].indexOf(x.key) >= 0);
    } else if (istLehrauftrag) {
      // Lehrauftrag-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "adresse", "bank", "werdegang"].indexOf(x.key) >= 0);
    } else if (istVortrag) {
      // Vortrag/Kolloquium-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "adresse", "bank"].indexOf(x.key) >= 0);
    } else if (istTarifvertrag) {
       // Alles außer buwbv, werkvertrag, studium erlauben
      mypanels = mypanels.filter(x => ["buwbv", "werkvertrag", "studienbereich"].indexOf(x.key) < 0);
    } else {
      // Alles außer buwbv+werkvertrag erlauben
      mypanels = mypanels.filter(x => ["buwbv", "werkvertrag"].indexOf(x.key) < 0);
    }

    return <span>
      <SHKFormTab
        readonly
        args={{ a_id: currentAntrag.a_id }}
        subpanels={mypanels}
        injects={selectInjects(this.props)}
      />
    </span>;
  }
}
